module.exports = __webpack_public_path__ + "static/profile-485c8868c4cb3d598b9bb0b933933e16.png";